'use strict';

// at the moment this service is only used for deleting uploaded files that
// are still in the tmp folder. Uploading files is handled by
// angular-file-upload.
(function () {
  angular
    .module('specsguardApp')
    .factory('UploadService', UploadService);

  UploadService.$inject = ['$resource'];

  function UploadService ($resource) {

    return $resource('/api/upload/:id', {
      id: '@_id'
    });
  }

})();
